<template>
    <div>
        <DxDataGrid
                :data-source="Organizations"
                :allow-column-reordering="true"
                :allow-column-resizing="true"
                :column-auto-width="true"
                :show-borders="true"
                width="100%"
                :show-row-lines="true"
                :row-alternation-enabled="true"
                >

                <DxPaging :page-size="5" />
                <DxHeaderFilter :visible="true" />
                <DxFilterRow :visible="true" />
                <DxColumn
                caption="Φορέας"
                data-field="Description"
                data-type="string"
                :visible="true"
                :allow-editing="false"
                alignment="left"
                width="60%" />
                <DxColumn
                    caption="Διαβάστηκε"
                    data-type="boolean"
                    :visible="true"
                    alignment="center"
                    data-field="IsSeen"
                >
                </DxColumn>
                <DxColumn
                caption="Ημερομηνία Προβολής"
                data-field="DateSeen"
                data-type="datetime"
                :visible="true"
                :allow-editing="false"
                format="dd/M/yy HH:mm"
                sort-order="desc"
                alignment="center" />
                <DxSummary>
                    <DxTotalItem
                    column="Id"
                    summary-type="count" />
                </DxSummary>
        </DxDataGrid>
    </div>
</template>
<script>
import {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxPaging,
    DxFilterRow,
    DxTotalItem,
    DxSummary,
} from "devextreme-vue/data-grid";
export default {
    components:{
        DxDataGrid,
        DxColumn,
        DxHeaderFilter,
        DxPaging,
        DxFilterRow,
        DxSummary,
        DxTotalItem
    },
    props:['organizations'],
    computed:{
        Organizations(){
            return this.organizations
        }
    }
}
</script>